import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'ri.payment.view.policy-details.Policy Details',
        defaultMessage: 'Policy Details: {policyNumber}'
    },
    currentTab: {
        id: 'ri.payment.view.policy-details.tab.Current',
        defaultMessage: 'Current'
    },
    changePolicy: {
        id: 'ri.payment.view.policy-details.Change Current Policy',
        defaultMessage: 'Change Current Policy'
    },
    renewalTab: {
        id: 'ri.payment.view.policy-details.tab.Renewing',
        defaultMessage: 'Renewing'
    },
    changeRenewalPolicy: {
        id: 'ri.payment.view.policy-details.Change Renewal Policy',
        defaultMessage: 'Change Renewal Policy'
    },
    DownloadIDCard: {
        id: 'ri.payment.view.policy-details.Download ID Card',
        defaultMessage: 'Download ID Card'
    }
});
